import React from "react";
import { Switch } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";

interface IGuideCombinationProps {
  active: boolean;
  visible: boolean;
  title: string;
  description: string;
}

const GuideCombination: React.FC<IGuideCombinationProps> = ({
  active,
  visible,
  title,
  description,
}) => (
  <div className="email-channel-guide-combination">
    <div className="email-channel-guide-state">
      <span className="email-channel-state-control">
        <Switch checked={active} disabled />
        <span className={active ? "is-active" : "is-inactive"}>
          <Localize>
            {active
              ? "EMAIL_CHANNEL.Status_Active"
              : "EMAIL_CHANNEL.Status_Inactive"}
          </Localize>
        </span>
      </span>
      <span
        className={`email-channel-guide-visibility ${
          visible ? "is-visible" : "is-hidden"
        }`}
      >
        {visible ? <Icons.Visible /> : <Icons.Hidden />}
        <Localize>
          {visible
            ? "EMAIL_CHANNEL.Visibility_Visible"
            : "EMAIL_CHANNEL.Visibility_Hidden"}
        </Localize>
      </span>
    </div>
    <strong><Localize>{title}</Localize></strong>
    <p><Localize>{description}</Localize></p>
  </div>
);

const EmailChannelStatusGuide: React.FC = () => (
  <div className="email-channel-guide">
    <h3><Localize>EMAIL_CHANNEL.Guide_Title</Localize></h3>
    <section className="email-channel-guide-intro">
      <strong><Localize>EMAIL_CHANNEL.Guide_Active_Title</Localize></strong>
      <p><Localize>EMAIL_CHANNEL.Guide_Active_Text</Localize></p>
      <strong><Localize>EMAIL_CHANNEL.Guide_Visible_Title</Localize></strong>
      <p><Localize>EMAIL_CHANNEL.Guide_Visible_Text</Localize></p>
    </section>
    <h4><Localize>EMAIL_CHANNEL.Guide_Combinations</Localize></h4>
    <GuideCombination
      active
      visible
      title="EMAIL_CHANNEL.Guide_Live_Title"
      description="EMAIL_CHANNEL.Guide_Live_Text"
    />
    <GuideCombination
      active
      visible={false}
      title="EMAIL_CHANNEL.Guide_Internal_Title"
      description="EMAIL_CHANNEL.Guide_Internal_Text"
    />
    <GuideCombination
      active={false}
      visible
      title="EMAIL_CHANNEL.Guide_Archived_Title"
      description="EMAIL_CHANNEL.Guide_Archived_Text"
    />
    <GuideCombination
      active={false}
      visible={false}
      title="EMAIL_CHANNEL.Guide_Off_Title"
      description="EMAIL_CHANNEL.Guide_Off_Text"
    />
  </div>
);

export default EmailChannelStatusGuide;
